import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=033ed976&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"
import style0 from "./forgot.vue?vue&type=style&index=0&id=033ed976&prod&lang=css"
import style1 from "./forgot.vue?vue&type=style&index=1&id=033ed976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ed976",
  null
  
)

export default component.exports